import { createExcelAndDownload } from '../../../../utils/reportExcelExport';

const isDebitTransaction = (type) => {
    const t = type?.toLowerCase();
    return t === 'invoice' || t === 'debit';
};

const getTransactionTypeLabel = (type) => {
    if (isDebitTransaction(type)) return 'Debit';
    if (type?.toLowerCase() === 'payment' || type?.toLowerCase() === 'credit') return 'Credit';
    return type || '';
};

export function Report(transactions, viewMode = 'amount') {
    const customHeadings = viewMode === 'ledger'
        ? [
            { key: "transaction_date", label: "Transaction Date", isDate: true },
            { key: "voucher_id.invoice_no", label: "Transaction ID", width: 25 },
            { key: "member_id.member_id", label: "Member ID" },
            { key: "member_id.name", label: "Member Name" },
            { key: "debit", label: "Debit" },
            { key: "credit", label: "Credit" },
            { key: "balance_after", label: "Balance" },
        ]
        : [
            { key: "transaction_date", label: "Transaction Date", isDate: true },
            { key: "voucher_id.invoice_no", label: "Transaction ID", width: 25 },
            { key: "member_id.member_id", label: "Member ID" },
            { key: "member_id.name", label: "Member Name" },
            { key: "amount", label: "Total Amount" },
            { key: "transaction_type", label: "Transaction Type" },
            { key: "balance_after", label: "Balance" },
        ];

    const exportRows = viewMode === 'ledger'
        ? transactions.map((transaction) => ({
            ...transaction,
            debit: isDebitTransaction(transaction.transaction_type) ? transaction.amount : 0,
            credit: isDebitTransaction(transaction.transaction_type) ? 0 : transaction.amount,
        }))
        : transactions;

    createExcelAndDownload("Member Financial  Report", exportRows, customHeadings, {
        transformCell: (key, value) => {
            if (key === 'transaction_type') return getTransactionTypeLabel(value);
            return value;
        },
    });
}

export function LedgerReport(transactions) {
    const customHeadings = [
        { key: "transaction_date", label: "Transaction Date", isDate: true },
        { key: "voucher_id.invoice_no", label: "Transaction ID", width:25 },
        { key: "member_id.member_id", label: "Member ID" },
        { key: "member_id.name", label: "Member Name" },
        { key: "member_id.phone", label: "Member Contact" },
        { key: "voucher_id.invoice_no", label: "Paid Voucher No" },
        {key:"subscription_id.renewed_date",label:"Subscription Start Date", isDate: true},
        {key:"subscription_id.end_date",label:"Subscription End Date", isDate: true},
        { key: "voucher_id.payment_method", label: "Payment Method" },
        { key: "voucher_id.reference_no", label: "Reference No" },
        { key: "amount", label: "Total Amount" },
        { key: "transaction_type", label: "Transaction Type" },
        { key: "balance_after", label: "Balance" },
    ];
    createExcelAndDownload("Ledgers Report", transactions, customHeadings, {
        transformCell: (key, value, item) => {
            if (key === "voucher_id.reference_no") {
                const method = item?.voucher_id?.payment_method?.toLowerCase();
                if (method === "jazzcash" || method === "online") {
                    return item?.voucher_id?.reference_no || "";
                }
                return "";
            }
            if (key === 'transaction_type' && value === 'Invoice') return 'Debit';
            if (key === 'transaction_type' && value === 'Payment') return 'Credit';
            return value;
        },
    });
}
